exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-box[data-v-10f4ef26]{width:100%;height:48px;line-height:48px;border-radius:3px;text-align:center;background-color:rgba(208,2,27,.04);color:#d36b75;margin-bottom:18px;font-size:14px;margin-top:16px;-webkit-transition:height .2s ease-in;-o-transition:height ease-in .2s;transition:height .2s ease-in}.show[data-v-10f4ef26]{height:0;font-size:0;-webkit-transition:all .2s ease-in;-o-transition:all ease-in .2s;transition:all .2s ease-in}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10f4ef26","scoped":true,"hasInlineConfig":true}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/errorMsg.vue
// module id = 498
// module chunks = 0 4 5 7 8 10